/**
 * Thinking indicator with animated shimmer skeleton.
 * Shows inside the assistant bubble while waiting for the first content.
 * Mimics Claude/ChatGPT "thinking" state with pulsing shimmer lines.
 */
export function ThinkingIndicator() {
  return (
    <div className="space-y-3 py-1">
      {/* Label with bouncing dots */}
      <div className="flex items-center gap-1.5">
        <span className="text-sm font-medium text-muted-foreground">Thinking</span>
        <div className="flex gap-0.5">
          <span className="thinking-dot w-1 h-1 rounded-full bg-primary/60" style={{ animationDelay: '0ms' }} />
          <span className="thinking-dot w-1 h-1 rounded-full bg-primary/60" style={{ animationDelay: '160ms' }} />
          <span className="thinking-dot w-1 h-1 rounded-full bg-primary/60" style={{ animationDelay: '320ms' }} />
        </div>
      </div>

      {/* Shimmer skeleton lines */}
      <div className="space-y-2.5 max-w-md">
        <div className="shimmer-line h-3 rounded-md w-[85%]" />
        <div className="shimmer-line h-3 rounded-md w-[70%]" style={{ animationDelay: '150ms' }} />
        <div className="shimmer-line h-3 rounded-md w-[55%]" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  )
}
